export default __webpack_public_path__ + "static/media/CF.aeccc17b.svg";